@if (display) {
  <astral-date-picker
    [control]="dateControl"
    [label]="title"
    [helpText]="helpText"
    [readonly]="readonly"
    [showEmptyReadOnly]="showEmptyReadOnly"
    [clearOthers]="clearOthers"
  ></astral-date-picker>
}
